import { fileShareViewAppPage } from '@wix/bi-logger-wixlabs-ugc/v2';
import { fileShareViewAppPageParams } from '@wix/bi-logger-wixlabs-ugc/src/types';

export const biFileShareWidgetAppLoaded = (props: any) => {
  const {
    instance_id,
    app_id,
    logger,
    visitor_id,
    comp_id,
    biToken,
    isEditor,
  } = props;
  const params: fileShareViewAppPageParams = {
    instance_id,
    app_id,
    visitor_id,
    comp_id,
    view_type: 'page app',
    app_site_id: instance_id,
  };
  if (isEditor) {
    params.biToken = biToken;
  }
  logger?.report(fileShareViewAppPage({ ...params }));
};
